import { useState } from "react"
import { Button, Form, FormGroup, Label, Input, Spinner } from "reactstrap"
import ThemeModal from "components/Common/ThemeModal"
import { useTagImporter } from "hooks/stockHook"
import { useToastMessage } from "hooks/useToastMessage"

const TagImporterByFullChassis = ({ importerId }) => {
  const { handleResponse, handleError } = useToastMessage()
  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => setIsOpen(!isOpen)
  const [chassisList, setChassisList] = useState("")

  const { mutateAsync: tagImporter, isPending: tagImporterLoading } =
    useTagImporter()

  const handleSubmit = async e => {
    e.preventDefault()

    const full_chassis_list = chassisList
      .split(/\r?\n/)
      .map(s => s.trim())
      .filter(s => s.length > 0)

    if (full_chassis_list.length === 0) {
      return handleResponse(
        {
          success: false,
          message: "Please enter at least one chassis number.",
        },
        "",
        true
      )
    }

    try {
      const res = await tagImporter({
        importer_id: importerId,
        full_chassis_list,
      })

      handleResponse(res, res.message || "", true)

      if (res.success) {
        setChassisList("") // Clear input after success
        toggle() // Close modal
      }
    } catch (error) {
      handleError(error)
    }
  }

  return (
    <>
      <Button
        size="sm"
        color="info"
        onClick={toggle}
        className="d-flex align-items-center gap-1 border-0"
        style={{ boxShadow: "none" }}
      >
        {/* handle with bx icon */}
        <i className="bx bx-tag font-size-16" />

        <span className="d-none d-sm-inline">Tag Vehicle</span>
      </Button>

      <ThemeModal
        isOpen={isOpen}
        toggle={toggle}
        title="Tag Vehicle by Full Chassis"
      >
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="chassisList">
              Chassis Numbers{" "}
              <small className="text-muted">(one per line)</small>
            </Label>

            <Input
              type="textarea"
              id="chassisList"
              rows="10"
              placeholder={`Example:
NKE165-7251102
MXPJ10-2023538
NRE161-0090201
ZWR80-0482845`}
              value={chassisList}
              onChange={e => setChassisList(e.target.value)}
            />
          </FormGroup>

          <Button color="primary" type="submit" disabled={tagImporterLoading}>
            {tagImporterLoading ? <Spinner size="sm" /> : "Update Importer"}
          </Button>
        </Form>
      </ThemeModal>
    </>
  )
}

export default TagImporterByFullChassis
